export default __webpack_public_path__ + "static/media/arrowClose_ico.34ce07a6.svg";